const LINK_LABELS: Record<string, string> = {
  entity: "Entity",
  individual: "Individual",
  removed_entity: "Removed entity",
  removed_individual: "Removed individual",
};

export const linkLabel = (linkType: string): string => {
  if (!linkType) {
    return "";
  }

  const knownLabel = LINK_LABELS[linkType];
  if (knownLabel) {
    return knownLabel;
  }

  const readable = linkType.replace(/[-_]+/g, " ").trim();
  if (!readable) {
    return "";
  }

  return readable.charAt(0).toUpperCase() + readable.slice(1).toLowerCase();
};
